// jQuery free
import {onDOMReady} from './dom';

const DATA_SHOW_HIDDEN_IN_TARGET = 'data-showhiddenintarget';
const DATA_SHOW_HIDDEN_INITIALIZED = 'data-showhidden-initialized';


function initTriggerElement(triggerElement) {
    if (triggerElement.hidden || triggerElement.hasAttribute(DATA_SHOW_HIDDEN_INITIALIZED)) {
        return;
    }

    triggerElement.setAttribute(DATA_SHOW_HIDDEN_INITIALIZED, 'true');
    triggerElement.addEventListener('click', (event) => {
        const targetElement = document.getElementById(triggerElement.getAttribute(DATA_SHOW_HIDDEN_IN_TARGET));
        if (targetElement) {
            for (const hiddenElement of targetElement.querySelectorAll(`:scope > [hidden]`)) {
                hiddenElement.hidden = false;
            }
        }
        triggerElement.hidden = true;
        event.preventDefault();
    });
}


const init = () => {
    for (const triggerElement of document.querySelectorAll(`[${DATA_SHOW_HIDDEN_IN_TARGET}]`)) {
        initTriggerElement(triggerElement);
    }
};


onDOMReady(init);
document.addEventListener('kvik_event_ajax_snippets_update', init);
